import { useQueryWithAuth } from '../../hooks/UseAuthQuery';
import { tmsBaseUrl, useGetWithNoStratusContext } from '../HttpClient';

export function useTenants() {
  // @ts-ignore
  const useSingleTenant = import.meta.env.VITE_USE_SINGLE_TENANT === 'true';
  // @ts-ignore
  const singleTenantId = import.meta.env.VITE_SINGLE_TENANT_ID;

  const tenantIdsToNames = {
    'd31e6785-bce7-4e3d-8471-156fdcd7d1ef': 'NewDay Cards (A03): d31e6785',
    'a03e09e3-c551-4e05-a695-a30603fe28ec': 'NewDay Cards (A03): a03e09e3',
    '0f8fc8ec-cd6f-4b4f-9dee-6b3b51cf0857': 'NewDay Cards (A03): 0f8fc8ec',
    'eda6dbc0-c7b8-4be0-a45a-867e7f78c7ba': 'Lloyds Banking Group (A06): eda6dbc0',
    'e8830fa0-3c8a-4c3f-90f4-e45264095b33': 'Lloyds Banking Group (LBG): e8830fa0',
    '3a4c9230-7b34-4676-b6b5-2b760213c00e': 'Lloyds Banking Group (A06): 3a4c9230',
    '79fb47d1-f871-4fa6-83d7-380705334fa0': 'Boohoo (A05): 79fb47d1',
    'cfb938bc-5dd9-451e-9cb0-0c20fdcb1b7b': 'Smoke Tests (TC1): cfb938bc',
    '4f61954b-83de-48d1-8794-b6a46da988af': 'Smoke Tests (SMK): 4f61954b',
    '22911d17-d669-4e18-bfc2-3f1cea686a8d': 'Smoke Tests (SMK): 22911d17',
    'd89601f5-281f-4a1e-8dcf-d898eed28b1a': 'Smoke Tests 2 (sm2): d89601f5',
    '08bd16c6-467f-4958-8a8a-fecabcf3a784': 'Retail Tests (RTL): 08bd16c6',
    '232b2d0d-0bd3-40f4-a226-c1c8af15b149': 'Non functional Testing (NTF): 232b2d0d',
    'c2f4d6d8-e466-4d47-85ce-95d7b699e915': 'Turbine (A08) c2f4d6d8'
  };

  const getTenantsQueryFn = async () => {
    if (useSingleTenant && !!singleTenantId) {
      return Promise.resolve([
        {
          tenandId: singleTenantId,
          tenantName: tenantIdsToNames[singleTenantId] ?? singleTenantId,
        },
      ]);
    }

    const tenants = await get<string[]>(`${tmsBaseUrl}/platform-service/tenants`);

    return tenants.map((t) => {
      return {
        tenandId: t,
        tenantName: tenantIdsToNames[t] ?? t,
      };
    });
  };

  const get = useGetWithNoStratusContext(true, 'tms');
  return useQueryWithAuth({
    queryKey: ['getTenants'],
    queryFn: () => getTenantsQueryFn(),
  });
}
